<template>
    <!-- don't prevent click event, or you will disabled click event -->
    <div class="container" @click="resetContextSetting">
        <div class="row">
            <div class="col-12">
                <file-input @newFile="handleEvent"></file-input>
                <ul>
                    <li v-for="item of files" @contextmenu.prevent="contextMenu($event, item)">
                        <a target="_blank" :href="`${base_url}/files/${item.identity}`">{{ item.name }}</a>
                    </li>
                </ul>
                <slot></slot>
            </div>
        </div>

        <div ref="contextMenu" v-show="contextMenuOn" @contextmenu.prevent>
            <ul>
                <li><a href="https://www.cnblogs.com/shouke/p/#" @click.prevent="fileShare">Share</a></li>
                <li><a href="https://www.cnblogs.com/shouke/p/#" @click.prevent="fileRename">Rename</a></li>
                <li><a href="https://www.cnblogs.com/shouke/p/#" @click.prevent="fileDelete">Delete</a></li>
            </ul>
        </div>

        <modal name="share" ref="shareModal">
            <div class="input-group mb-3">
                <input type="text" class="form-control" :value="theFileURL" readonly
                       aria-label="The url of the file on the server">
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary" @click.prevent="copyURL">copy</button>
                </div>
            </div>
            <div class="input-group">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="defaultCheck1">
                    <label class="form-check-label" for="defaultCheck1">
                        Allow anonymous access
                    </label>
                </div>
            </div>
            To be complete
        </modal>

        <modal name="Rename" ref="renameModal">
            <div class="input-group">
                <input type="text" class="form-control" placeholder="Set the name of the file" :value="theFileName"
                       ref="newName" aria-label="Name of the file with two button addons"
                       aria-describedby="button-addon">
                <div class="input-group-append" id="button-addon4">
                    <button class="btn btn-success" type="button" title="save" @click.prevent="renameSave">✓</button>
                    <button class="btn btn-secondary" type="button" title="cancel" @click.prevent="renameCancel">✕
                    </button>
                </div>
            </div>
        </modal>

        <modal name="Delete" ref="deleteModal">
            Are you sure to delete {{ theFileName }}?
            <template v-slot:footer>
                <button type="submit" class="btn btn-danger" @click.prevent="deleteConfirm">Yes</button>
                <button type="submit" class="btn btn-secondary" @click.prevent="deleteCancel">No</button>
            </template>
        </modal>

    </div>
</template>
<script>
import Vue from 'vue';
import {copyTextToClipboard} from "../../library/copyTextToClipboard";

export default {
    data() {
        return {
            base_url,
            contextMenuOn: false,
            files: [],
            theFile: undefined
        };
    },
    mounted() {
        fetch('api/files')
            .then(response => response.json())
            .then(result => {
                this.files = result
            })
    },
    methods: {
        contextMenu(event, file) {
            console.log(event);
            this.contextMenuOn = true;
            this.theFile = file;

            let menuDOM = this.$refs.contextMenu;
            // 顯示自定義的選單調整位置
            // not really need
            // refs: https://www.uj5u.com/qiye/167020.html
            let scrollTop =
                document.documentElement.scrollTop ||
                document.body.scrollTop;// 獲取垂直滾動條位置

            let scrollLeft =
                document.documentElement.scrollLeft ||
                document.body.scrollLeft;// 獲取水平滾動條位置

            menuDOM.style.left = event.clientX + scrollLeft + 'px';
            menuDOM.style.top = event.clientY + scrollTop + 'px'

            menuDOM.style.position = 'fixed';
            menuDOM.style.backgroundColor = '#BFBFBFBF';
            menuDOM.style.left = `${event.clientX}px`;
            menuDOM.style.top = `${event.clientY}px`;
        },
        copyURL() {
            copyTextToClipboard(this.theFileURL)
                .then(() => {
                    Vue.notify('The URL copied success!');
                })
                .catch(console.warn);
        },
        deleteCancel() {
            this.$refs.deleteModal.modalHide();
        },
        deleteConfirm() {
            axios.delete(`${base_url}/api/files/${this.theFile.identity}`)
                .then(response => {
                    let {data} = response;
                    this.files.splice(
                        this.files.findIndex(file => file.id === data.id),
                        1
                    );
                    this.deleteCancel();
                })
                .catch((error) => {
                    // not work since `fetch` reject return `<never>` parameter
                    let {response} = error,
                        {data} = response,
                        {message} = data;
                    if (message) {
                        Vue.notify({message, class: 'danger'});
                    } else {
                        console.log([error]);
                    }
                });
        },
        fileShare() {
            this.$refs.shareModal.modalShow();
        },
        fileRename() {
            this.$refs.renameModal.modalShow();
        },
        fileDelete() {
            this.$refs.deleteModal.modalShow();
        },
        handleEvent(newFile) {
            this.files.push(newFile);
        },
        renameCancel() {
            this.$refs.renameModal.modalHide();
        },
        renameSave() {
            axios.patch(`${base_url}/api/files/${this.theFile.identity}`, {name: this.$refs.newName.value})
                .then(response => {
                    let {data} = response;
                    this.theFile.name = data.name;
                    this.renameCancel();
                })
                .catch((error) => {
                    // not work since `fetch` reject return `<never>` parameter
                    let {response} = error,
                        {data} = response,
                        {message} = data;
                    if (message) {
                        Vue.notify({message, class: 'danger'});
                    } else {
                        console.log([error]);
                    }
                });
        },
        resetContextSetting() {
            this.contextMenuOn = false;
            // if reset this variable when click, no matter what you choose to do, but no thing to pass through.
            // this.theFile = undefined;
        }
    },
    computed: {
        theFileURL() {
            return this.theFile ? `${base_url}/files/${this.theFile.identity}` : null;
        },
        theFileName() {
            return this.theFile ? this.theFile.name : null;
        }
    }
}
</script>
